"use client";

import { WlkpCompany, WlkpCompanyCard } from "@entities/employer";
import { Button } from "@ubud-ui/react-ui-kit";

export function WlkpCompanySelectionPreview({ company, onChange }: { company?: WlkpCompany | null; onChange?: () => void }) {
  if (!company) return <></>;

  return (
    <div>
      <div className="mb-4 flex items-center gap-4">
        <h4 className="flex-1 text-base font-bold">Perusahaan WLKP</h4>
        <Button className="text-sm font-bold m-0 p-0 w-auto h-auto" variant="link" onClick={onChange}>
          Ubah
        </Button>
      </div>
      <WlkpCompanyCard company={company} />
    </div>
  );
}
